import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Auth, fb, db, algolia_client } from '../../index';
import "./home.css";
import 'firebase/firestore';
import Table from './survey-table/table';
import Footer from './footer/footer';
import SearchBar from './search-bar/search-bar';
import Header from './header/header';
import Homecontainer from './home-container/home-container';

export const headerType = {
    HOME: "HOME",
    UPLOAD: "UPLOAD",
    ABOUT: "ABOUT"
}

const Home = ( {signedIn, handleLogOut} ) => {
    const [surveyData, setSurveyData] = useState()
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Auth.onAuthStateChanged(user => {
        //     if (!user) history.push("/sign-in")
        // })
        getSurvey()
    }, [signedIn])//skip applying the effect when the signedIn status haven't change between re-renders

    const getSurvey = () => {

        setLoading(true)

        const loadingTimeOut = setTimeout(() => {
            setLoading(false)
        }, 5000);

        const ref = fb.firestore().collection("submittedSurvey");
        ref.onSnapshot((querySnapShot) => {
            const items = [];
            querySnapShot.forEach((doc) => {
                items.push(doc.data());
            })
            setSurveyData(items)
            clearTimeout(loadingTimeOut);
            setLoading(false);
        })
    }

    const searchSurvey = (searchTerm, filter) => {
        if (searchTerm.length === 0) {
            const ref = fb.firestore().collection("submittedSurvey");
            ref.onSnapshot((querySnapShot) => {
                const items = [];
                querySnapShot.forEach((doc) => {
                    items.push(doc.data());
                })
                setSurveyData(items)
            })
        } else {
            fb.firestore().collection("submittedSurvey")
                .where(filter, "==", searchTerm)
                .get()
                .then((querySnapShot) => {
                    const items = [];
                    querySnapShot.forEach((doc) => {
                        items.push(doc.data());
                    })
                    setSurveyData(items)
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                })
            // Algolia search code. Need to config index addition in the submit page.
            // return index.search(searchTerm, {
            //         attributesToRetrieve:
            //             ['project_name', 'project_description', 'project_association', 'project_platform', 'deadline', 'survey_link', 'survey_language', 'target_group'],
            //         hitsPerPage: 50,
            //     })
            //     .then((responses) => {
            //         setSurveyData(responses.hits);
            //     })
        }
    }

   const handleTestUploadButton = () => {
    db.collection('submittedSurvey').add({
        censored: false,
        survey_name: "test",
        survey_description: "test",
        survey_platform: "test",
        survey_link: "test",
        survey_association: "test",
        survey_language: "test",
        target_group: "test",
        deadline: "test",
        deadlineTime: "test",
        survey_more_details: "test",
        timestamp: Date.now(),
        uid: "00000000"
    });
   }

    if (loading) return <h1 id='loading-indicator'>Loading......</h1>;

    const tableContent = () => {
        if ((surveyData && (surveyData.length !== 0))) {
            return <Table data={surveyData} />
        } else if ((surveyData && (surveyData.length === 0))){
            return <h1 id='not-found-text'>No survey Found</h1>
        } else {
            return <h1 id='load-failed-text'>Loading Failed. Check your internet or VPN connection and try again</h1>
        }
    }

    return (
        <>
            <Header signedIn={signedIn} handleLogOut={handleLogOut} param={headerType.HOME}/>
            <Homecontainer signedIn={signedIn}/>
            <div id='main-content'>
                <SearchBar searchSurvey={searchSurvey}/>
                {tableContent()}
            </div>
            <Footer/>
        </>
    );
}

export default Home;